import request from '@/utils/http';

export const getAccountLists = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getDepositTransfer`,
        method: 'get',
        params
    });
};

export const getReceivableLists = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/getDepositbillNumber`,
        method: 'post',
        data
    });
};

// 图片删除、
export const getPictureDeletion = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/removeAllByPkt`,
        method: 'post',
        data
    });
};